import { useFlags } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from 'store';

import { LD_FLAG_ENABLE_SESSION_REPLAY } from 'common/featureFlags/launchDarklyFlags';
import { startNetworkObservability, stopNetworkObservability } from 'common/featureFlags/observability';
import { startSessionReplay, stopSessionReplay } from 'common/featureFlags/sessionReplay';

/**
 * Records any logged-in session while `enable-session-replay` is on. Network capture
 * (the observability plugin) is a separate engine from session replay and needs its own
 * start/stop, kept in lockstep with the same flag so it's never running independently.
 */
export const useSessionReplay = (): void => {
    const activeUser = useSelector((state: RootState) => state.auth?.activeUser);
    const flags = useFlags();

    const shouldRecord = Boolean(flags[LD_FLAG_ENABLE_SESSION_REPLAY]) && Boolean(activeUser?.pk);

    useEffect(() => {
        if (shouldRecord) {
            void startSessionReplay();
            void startNetworkObservability();

            return;
        }

        stopSessionReplay();
        void stopNetworkObservability();
    }, [shouldRecord]);
};
